// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import { VersionableFragmentDoc } from '../../../../components/ReadyPlanVersionHeader.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageTakeoffPageQueryVariables = Types.Exact<{
  planPackageId: Types.Scalars['ID']['input'];
  rpavId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type PlanPackageTakeoffPageQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, name: string, displayName: string, displayCode?: string | null | undefined, version: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, displayVersion: string, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus, name: string } }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, displayVersion: string, versionNotes?: string | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus, name: string } }>, canEditLineItems: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, aggregateActive?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } } | null | undefined, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, canPublish: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, active: boolean, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }>, programData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, active: boolean, isCoverPhoto: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } }>, incomingSlots: Array<{ __typename?: 'PlanPackageIncomingSlot', id: string, status: { __typename?: 'PlanPackageIncomingSlotStatusDetail', code: Types.PlanPackageIncomingSlotStatus }, designPackagePlaceholder: { __typename?: 'TakeoffLineItem', id: string } }> } };

export type PlanPackageTakeoffPage_TakeoffDetailFragment = { __typename?: 'PlanPackage', id: string, name: string, displayName: string, displayCode?: string | null | undefined, version: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, displayVersion: string, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus, name: string } }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, displayVersion: string, versionNotes?: string | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus, name: string } }>, canEditLineItems: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, aggregateActive?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } } | null | undefined, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, canPublish: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, active: boolean, order: number, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }>, programData: { __typename?: 'ProgramData', id: string, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, sellableSqft?: number | null | undefined }, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, active: boolean, isCoverPhoto: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } }>, incomingSlots: Array<{ __typename?: 'PlanPackageIncomingSlot', id: string, status: { __typename?: 'PlanPackageIncomingSlotStatusDetail', code: Types.PlanPackageIncomingSlotStatus }, designPackagePlaceholder: { __typename?: 'TakeoffLineItem', id: string } }> };

export const PlanPackageTakeoffPage_TakeoffDetailFragmentDoc = gql`
    fragment PlanPackageTakeoffPage_TakeoffDetail on PlanPackage {
  id
  name
  displayName
  version {
    id
    version
    displayVersion
    status {
      code
      name
    }
  }
  status: effectiveStatus {
    code
    name
  }
  aggregateVersions {
    id
    version
    displayVersion
    versionNotes
    status {
      code
      name
    }
  }
  canEditLineItems {
    ...PotentialOperationDetails
  }
  aggregateActive {
    ...Versionable
  }
  aggregateDraft {
    ...Versionable
    canPublish {
      ...PotentialOperationDetails
    }
  }
  displayCode
  options {
    id
    displayName
    active
    type {
      id
      isElevation
    }
    location {
      id
      name
    }
    order
  }
  programData {
    id
    bedrooms
    fullBaths
    sellableSqft
  }
  assets {
    id
    active
    isCoverPhoto
    asset {
      id
      previewUrl(resizing: {width: 400, region: FULL})
    }
  }
  incomingSlots {
    id
    status {
      code
    }
    designPackagePlaceholder {
      id
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${VersionableFragmentDoc}`;
export const PlanPackageTakeoffPageDocument = gql`
    query PlanPackageTakeoffPage($planPackageId: ID!, $rpavId: ID) {
  planPackage(id: $planPackageId, versionId: $rpavId) {
    ...PlanPackageTakeoffPage_TakeoffDetail
  }
}
    ${PlanPackageTakeoffPage_TakeoffDetailFragmentDoc}`;

/**
 * __usePlanPackageTakeoffPageQuery__
 *
 * To run a query within a React component, call `usePlanPackageTakeoffPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageTakeoffPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageTakeoffPageQuery({
 *   variables: {
 *      planPackageId: // value for 'planPackageId'
 *      rpavId: // value for 'rpavId'
 *   },
 * });
 */
export function usePlanPackageTakeoffPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackageTakeoffPageQuery, PlanPackageTakeoffPageQueryVariables> & ({ variables: PlanPackageTakeoffPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageTakeoffPageQuery, PlanPackageTakeoffPageQueryVariables>(PlanPackageTakeoffPageDocument, options);
      }
export function usePlanPackageTakeoffPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageTakeoffPageQuery, PlanPackageTakeoffPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageTakeoffPageQuery, PlanPackageTakeoffPageQueryVariables>(PlanPackageTakeoffPageDocument, options);
        }
// @ts-ignore
export function usePlanPackageTakeoffPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageTakeoffPageQuery, PlanPackageTakeoffPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageTakeoffPageQuery, PlanPackageTakeoffPageQueryVariables>;
export function usePlanPackageTakeoffPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageTakeoffPageQuery, PlanPackageTakeoffPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageTakeoffPageQuery | undefined, PlanPackageTakeoffPageQueryVariables>;
export function usePlanPackageTakeoffPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageTakeoffPageQuery, PlanPackageTakeoffPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageTakeoffPageQuery, PlanPackageTakeoffPageQueryVariables>(PlanPackageTakeoffPageDocument, options);
        }
export type PlanPackageTakeoffPageQueryHookResult = ReturnType<typeof usePlanPackageTakeoffPageQuery>;
export type PlanPackageTakeoffPageLazyQueryHookResult = ReturnType<typeof usePlanPackageTakeoffPageLazyQuery>;
export type PlanPackageTakeoffPageSuspenseQueryHookResult = ReturnType<typeof usePlanPackageTakeoffPageSuspenseQuery>;
export type PlanPackageTakeoffPageQueryResult = Apollo.QueryResult<PlanPackageTakeoffPageQuery, PlanPackageTakeoffPageQueryVariables>;